export function generateHreflangLinks(fullPath: string, siteUrl: string, selectedLang: string, locales: any) {
  const cleanPath = fullPath.replace(new RegExp(`^/(?:${selectedLang})`), '');
  
  return locales
    .filter((loc:any) => loc.code !== selectedLang) 
    .map((loc: any) => ({
      rel: 'alternate',
      hreflang: loc.code,
      href: `${siteUrl}${loc.prefix}${cleanPath}`
    }));
}
